import { ASSETS_URL } from "./urls"

let STYLES = {
  trial: {
    landing: {
      deviceId: 25122,
      banner: {
        en:
          `<style>#banner {position: relative; width: 100%;} #banner img {width: 100%;border-bottom-left-radius: 8px;border-bottom-right-radius: 8px;} #banner div {position: absolute;text-align: right;} #banner h2 {margin-bottom: 0px;color: #00ADEF; font-weight: bold;} #banner p {color: #777;} @media (min-width: 992px){#banner div {top: 18%;right: 5%;}} @media (max-width: 499px){#banner div {top: 0%;right: 3%;} #banner h2 {font-size: .85em} #banner p {display: none}} @media (min-width: 500px) and (max-width: 991px){#banner div {top: 2%;right: 3%;} #banner h2 {font-size: 1.5em} #banner p {font-size: .85em}}</style><div id='banner'><img src='${ASSETS_URL}}/academy-assets/banners/trial-banner-1.jpg' /><div><h2>PROFESSIONAL SUPPORT</h2><p>We have the answers to your questions</p></div>`
      }
    },
    faq: {
      contentColor: '#54c1f7',
      titleColor: '#5f5f60'
    },
    footer: {
      backgroundColor: '#EEEEEE',
      fontColor: '#8f8f90',
      footerLogo: 'https://s3.amazonaws.com/devicebits-trial-logos/dblogo.png',
      logoHeight: '35px'
    },
    guides: {
      backButton: '#00ADEF',
      fontColor: '#8D8D8D',
      resolvedBackground: '#00ADEF',
      resolvedColor: '#FFF'
    },
    header: {
      backgroundColor: '#EEEEEE',
      breadcrumbLinks: '#00ADEF',
      breadcrumbText: '#5f5f60',
      fontColor: '#5f5f60',
      headerLogo: 'https://s3.amazonaws.com/devicebits-trial-logos/dblogo.png',
      logoHeight: '50px'
    },
    infoBar: {
      dropdownColor: '#00ADEF'
    },
    moreHelpFooter: {
      buttonColor: '#00ADEF',
      buttonTextColor: '#FFF',
      contactEmail: 'info@devicebits.com',
      contactPhone: '1.844.4DEVBITS',
      textColor: '#5f5f60'
    },
    navTile: {
      backgroundColor: '#00ADEF',
      color: '#FFF',
      columnLink: '#00ADEF',
      hoverHighlight: 'rgba(0,173,239,.6)'
    },
    pageTitle: 'DeviceBits Demo',
    relatedSideBar: {
      borderColor: 'rgba(0,173,239,.4)',
      linkColor: '#54c1f7',
      textColor: '#8D8D8D'
    },
    searchBar: {
      backgroundColor: '#00ADEF',
      color: '#FFF',
      focusHighlight: 'rgba(0,173,239,.6)',
      resultLink: '#00ADEF',
      resultTitle: '#5f5f60'
    },
    specs: {
      contentColor: '#5f5f60',
      listDots: '#00ADEF',
      phoneTitle: '#00ADEF',
      tryButtonBackground: '#00ADEF',
      tryButtonFont: '#FFF'
    },
    tutorial: {
      circle: {
        background: '#FFF',
        border: '#8D8D8D',
        text: '#8D8D8D'
      },
      circleActive: {
        background: '#00ADEF',
        border: '#00ADEF',
        text: '#FFF'
      },
      circleComplete: {
        background: '#8D8D8D',
        border: '#8D8D8D',
        text: '#FFF'
      },
      fontColor: '#8D8D8D'
    }
  }
}

export default STYLES



// WEBPACK FOOTER //
// ./src/constants/styles.js